import React from 'react';

const CircleIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 7.02942 16.9706 2.99998 12 2.99998C7.02944 2.99998 3 7.02942 3 12C3 16.9705 7.02944 21 12 21C16.9706 21 21 16.9705 21 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleIcon;
